export default __webpack_public_path__ + "static/pic3-6ae43b141a662f41e62d825db0fb15c4.jpg";